import { defineStore } from 'pinia';
import api from '@/common/utils/api';
import { TaskState, type BackendTask, type VhsDeploy, type VhsServiceInfo } from '@schema';
import type { VhsComputeNodePayload } from '@/common/store/pinia/vhsNodes';
import { computed, ref } from 'vue';
import { TaskName } from '@/common/constants/taskNames.constants';
import takeFirst from '@/common/utils/takeFirst';

export const useVhsDeployStore = defineStore('vhsDeploy', () => {
  const info = ref<VhsServiceInfo>();

  const isDeployed = computed(() => info.value ? info.value.status !== 'ABSENT' : false);

  const fetch = async () => {
    const { data } = await api.get<VhsServiceInfo>('/api/v2/vhs');
    info.value = data;
  };
  type DeployPayload = Omit<VhsDeploy, 'compute_nodes'> & {
    compute_nodes: VhsComputeNodePayload[];
  };

  const deploy = (payload: DeployPayload) => api.post<BackendTask>('/api/v2/vhs', payload);
  const destroy = () => api.delete<BackendTask>('/api/v2/vhs');

  const onTasks = async (task: BackendTask) => {
    if (
      (task.name === TaskName.VHS_COMPUTE_DESTROY || task.name === TaskName.VHS_DEPLOY)
      && task.state === TaskState.SUCCESS
    ) {
      await takeFirst(fetch);
    }
  };

  return {
    info,
    isDeployed,
    fetch,
    deploy,
    destroy,
    onTasks
  };
}, {
  ws: {
    tasks: 'onTasks'
  }
});

export default useVhsDeployStore;
